import * as React from 'react'
import { useEffect, useState } from 'react'

import { getRedirectableLink, isAbsoluteUrl } from '../../hooks/isAbsoluteUrl'
import { darkTheme, defaultTheme } from '../../theme'
import { darkHeader, lightHeader } from '../../theme/components.css'
import { Button } from '../button'
import { Icon } from '../icon'
import * as DD from '../navigation/Dropdown'
import * as NavBar from '../navigation/NavBar'
import Container from '../shared/Container'
import headerData from './header'
import {
  Articles,
  CompanyDropdownContainer,
  ContainerStyle,
  DeveloperDropdownContainer,
  GithubLink,
  HeaderCtaContainer,
  HeaderCtaLink,
  HeaderStyle,
  HiddenOnMobile,
  LoginBtn,
  MenuToggleBtn,
  MobileHeader,
  openNav,
  PlaygroundItem,
  PlaygroundLink,
  PlaygroundLogo,
  playgroundLogoColor,
  PlaygroundTitle,
  PlaygroundTitleBase,
} from './index.css'
import { xmlToJson } from './xmlToJson'

type ColorType = 'indigo' | 'teal' | 'white' | undefined

interface HeaderProps {
  className?: string
  color?: ColorType
  lightTheme?: boolean
  absoluteLinks?: boolean
  navbarItems?: any
  loc?: any
}

const Header = ({
  className,
  lightTheme = true,
  absoluteLinks = false,
  color = 'indigo',
  navbarItems = {},
  loc,
}: HeaderProps) => {
  let themeToUse = lightTheme ? defaultTheme : darkTheme
  const [blogPosts, setBlogPosts]: any = React.useState([])
  
  let navPathnames: string[] = []

  if (headerData) {
    headerData.map((navbarItem: any) => {
      switch (navbarItem._type) {
        case 'linkType':
          navPathnames.push(navbarItem.url.slice(1))
        case 'linksWithCategoryType': {
          navbarItem &&
            navbarItem.category &&
            navbarItem.category.map((cat: any) => {
              cat.links.map((link: any) => navPathnames.push(`${navbarItem.url.slice(1)}_${link.url.slice(1)}`))
            })
        }
        case 'arrayOfLinksType': {
          navbarItem &&
            navbarItem.links &&
            navbarItem.links.map((link: any) => navPathnames.push(`${navbarItem.url.slice(1)}_${link.url.slice(1)}`))
        }
      }
    })
  }

  // Pull latest 2 blog posts
  useEffect(() => {
    fetch('https://prismablog.vercel.app/blog/rss.xml', {
      method: 'GET',
    })
      .then((response) => response.text())
      .then((str) => new window.DOMParser().parseFromString(str, 'text/xml'))
      .then((data) => {
        const posts: any = xmlToJson(data).rss.channel.item
        setBlogPosts([posts[0], posts[1]])
      })
  }, [])

  const [topNav, setTopNav] = useState('/')
  const [activeNav, setActiveNav] = useState('/')

  useEffect(() => {
    let pathname = window.location.pathname
    let windowPath = ['']
    if (pathname.includes('docs')) {
      handleNavClick('docs', '')
    } else {
      windowPath = navPathnames.filter((e) => {
        if (pathname.charAt(pathname.length - 1) === '/') pathname = pathname.substring(1, pathname.length - 1)
        return e.includes(pathname.substring(1)) ? e : ''
      })
      if (windowPath.length > 0 && pathname !== '/') {
        handleNavClick(windowPath[0].split('_')[0], windowPath[0].split('_')[1])
      } else {
        handleNavClick('', '')
      }
    }
  }, [navPathnames])

  const handleNavClick = (top: string, bottom: string) => {
    setTopNav(top)
    setActiveNav(bottom ? bottom : '')
  }

  return (
    //@ts-ignore
    <div className={`${HeaderStyle} ${lightTheme ? lightHeader : darkHeader}`}>
      <NavBar.NavBar lightTheme={lightTheme}>
        <NavBar.NavBarContext.Consumer>
          {({ state: { mobileOpen } }) => (
            <>
              <div className={className + (mobileOpen ? ` ${openNav}` : '')}>
                <Container className={ContainerStyle}>
                  <NavBar.NavBarInner>
                    <div className={MobileHeader}>
                      <a href="https://www.prisma.io" style={{ height: `27px` }}>
                        <img
                          src={themeToUse.header.logoUrl}
                          width={90}
                          height={27}
                          alt="prisma_logo"
                          style={{ cursor: 'pointer', display: 'block' }}
                        />
                      </a>
                      <NavBar.MenuButton className={MenuToggleBtn} color={color} />
                    </div>

                    <NavBar.NavItemsContainer
                      color={color}
                      lightTheme={lightTheme}
                      className={mobileOpen ? '' : HiddenOnMobile}
                    >
                      {headerData.map((navbarItem: any) => {
                        switch (navbarItem._type) {
                          case 'linkType':
                            return (
                              <NavBar.NavItem
                                lightTheme={lightTheme}
                                href={getRedirectableLink(navbarItem.url, absoluteLinks)}
                                active={topNav === navbarItem.url.slice(1) && activeNav === ''}
                                onClick={() => handleNavClick(navbarItem.url, '')}
                                color={color}
                                title={navbarItem.title}
                              />
                            )
                          case 'linksWithCategoryType':
                            return (
                              <NavBar.NavItem
                                lightTheme={lightTheme}
                                color={color}
                                title={navbarItem.title}
                                active={topNav === navbarItem.url.slice(1)}
                                dropdown={
                                  <DD.Panel lightTheme={lightTheme} width={navbarItem.width}>
                                    {navbarItem.category.map((cat: any) => (
                                      <>
                                        <DD.SectionHeader lightTheme={lightTheme}>{cat.categoryTitle}</DD.SectionHeader>
                                        {cat.links.map((link: any) => (
                                          <DD.IconLink
                                            color={color}
                                            lightTheme={lightTheme}
                                            label={link.tag}
                                            href={getRedirectableLink(link.url, absoluteLinks)}
                                            active={activeNav === link.url.slice(1)}
                                            onClick={() => handleNavClick(navbarItem.url, link.url)}
                                            icon={
                                              <Icon
                                                icon={`fa-regular fa-${link.icon}`}
                                                size="1.3rem"
                                                color={defaultTheme.colors[color]['600']}
                                              />
                                            }
                                            external={link.external}
                                            title={link.title}
                                            subtitle={link.subtitle}
                                          />
                                        ))}
                                      </>
                                    ))}
                                  </DD.Panel>
                                }
                              />
                            )
                          case 'arrayOfLinksType':
                            return (
                              <NavBar.NavItem
                                lightTheme={lightTheme}
                                title={navbarItem.title}
                                color={color}
                                active={topNav === navbarItem.url.slice(1)}
                                dropdown={
                                  <DD.Panel
                                    lightTheme={lightTheme}
                                    width={navbarItem.width}
                                    col={navbarItem.url === '/resources' ? 2 : 1}
                                    isDeveloperSection={navbarItem.url === '/resources'}
                                  >
                                    <div className={`${navbarItem.url === '/company' && CompanyDropdownContainer}`}>
                                      <div
                                        className={`${navbarItem.url === '/resources' && DeveloperDropdownContainer} ${
                                          navbarItem.url === '/company' && 'company-links'
                                        }`}
                                      >
                                        {navbarItem.links.map((link: any) => (
                                          <DD.IconLink
                                            color={color}
                                            label={link.tag}
                                            col={navbarItem.url === '/resources'}
                                            lightTheme={lightTheme}
                                            href={getRedirectableLink(link.url, absoluteLinks)}
                                            titleOnlyOnMobile
                                            active={activeNav === link.url.slice(1)}
                                            onClick={() => handleNavClick(navbarItem.url, link.url)}
                                            external={link.external}
                                            icon={
                                              <Icon
                                                icon={`fa-regular fa-${link.icon}`}
                                                size="1.3rem"
                                                color={defaultTheme.colors[color]['600']}
                                              />
                                            }
                                            title={link.title}
                                            subtitle={link.subtitle}
                                          />
                                        ))}
                                      </div>
                                      {navbarItem.url === '/company' && (
                                        <>
                                          <DD.VerticalDivider />

                                          <div className={Articles}>
                                            <DD.ArticlesHeader>Latest from the blog</DD.ArticlesHeader>
                                            {blogPosts &&
                                              blogPosts.length !== 0 &&
                                              blogPosts.map((post: any) => (
                                                <DD.ArticleLink
                                                  href={post.link['#text']}
                                                  image={
                                                    <img
                                                      src={post.image['@attributes'].href}
                                                      alt={post.titletoread['#text']}
                                                      width={148}
                                                      height={83}
                                                      style={{
                                                        borderRadius: '4px',
                                                      }}
                                                    />
                                                  }
                                                  title={post.titletoread['#text']}
                                                />
                                              ))}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    {navbarItem.url === '/resources' && navbarItem.playground && (
                                      <a
                                        className={PlaygroundItem}
                                        href={navbarItem.playground.url}
                                        {...(navbarItem.external ? { target: '_blank', rel: 'noopener' } : {})}
                                      >
                                        <div
                                          className={`${PlaygroundTitleBase} ${
                                            PlaygroundTitle[color ? color : 'indigo']
                                          }`}
                                        >
                                          <img
                                            className={playgroundLogoColor[color ? color : 'indigo']}
                                            src={navbarItem.playground.logo}
                                          />
                                          <span
                                            className={PlaygroundLink}
                                            dangerouslySetInnerHTML={{ __html: navbarItem.playground.title }}
                                          />
                                        </div>
                                        <img
                                          width={258}
                                          style={
                                            navbarItem.playground.padding
                                              ? { padding: navbarItem.playground.padding }
                                              : {}
                                          }
                                          src={navbarItem.playground.img}
                                          className={PlaygroundLogo}
                                        />
                                      </a>
                                    )}
                                  </DD.Panel>
                                }
                              />
                            )
                        }
                      })}
                    </NavBar.NavItemsContainer>

                    <div className={`${HeaderCtaContainer} ${mobileOpen ? `` : HiddenOnMobile}`}>
                      <a
                        className={`${HeaderCtaLink} ${GithubLink}`}
                        href="https://github.com/prisma"
                        target="_blank"
                        rel="noopener"
                      >
                        {!mobileOpen && (
                          <Icon
                            icon={'fa-brands fa-github'}
                            size="1.375rem"
                            color={defaultTheme.colors[lightTheme ? 'black' : 'white']}
                          />
                        )}
                      </a>
                      <Button
                        transparent={true}
                        type="primary"
                        className={!lightTheme ? LoginBtn[color !== 'white' ? color : 'indigo'] : ``}
                        color={!lightTheme ? 'white' : color === 'white' ? 'indigo' : color}
                        href={loc || ""}
                      >
                        Login
                      </Button>
                      <Button
                        transparent={false}
                        type="primary"
                        color={color === 'white' ? 'indigo' : color}
                        href={`${absoluteLinks ? 'https://www.prisma.io' : ''}/docs/getting-started`}
                      >
                        Get started
                      </Button>
                    </div>
                  </NavBar.NavBarInner>
                </Container>
              </div>
            </>
          )}
        </NavBar.NavBarContext.Consumer>
      </NavBar.NavBar>
    </div>
  )
}

export { Header }
